import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorBoundary from '@components/ErrorBoundary';
import ErrorsPage from '@components/ErrorsPage';
import ContextProvider from '@context';
import Routes from '@route-gateway';
import DayJSUtils from '@date-io/dayjs';
import { SWRConfig } from 'swr';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { BASE_URL } from '@constants';

const fetcher = (resource, init) => fetch(resource, init).then(res => res.json());

function App() {
  return (
    <ErrorBoundary render={() => <ErrorsPage />}>
      <MuiPickersUtilsProvider utils={DayJSUtils}>
        <SWRConfig value={{ errorRetryCount: 2, errorRetryInterval: 2000, fetcher }}>
          <ContextProvider>
            <Router basename={BASE_URL}>
              <Routes />
            </Router>
          </ContextProvider>
        </SWRConfig>
      </MuiPickersUtilsProvider>
    </ErrorBoundary>
  );
}

export default App;
